
<div class="dialog-title" *ngIf="result.title">
  {{ result.title }}
</div>
<div *ngIf = "result.showContent">
<div class="dialog-description" *ngIf="result.content">
  {{ result.content }}
</div>
</div>

<div class="value-container">
  <div class="content-wrapper full" *ngIf= "result.showLabel">
    <div class="label-f">{{result.labelTitle}}</div>
    <div class="value-f">{{result.labelName}}</div>
  </div>
</div>

<div *ngIf="result.showTextBox">
  <mat-form-field class="example-full-width">
    <input
      matInput
      placeholder="{{ result.placeholder }}"
      [(ngModel)]="txtValue"
      name="txt"
      required
    />
  </mat-form-field>
</div>

<div class="dialog-buttons no-divider">
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="close()"
    *ngIf="!result.hideNoBtn"
  >
    {{ result.no }}
  </button>
  <button
    mat-button
    color="primary"
    cdkFocusInitial
    [mat-dialog-close]="true"
    *ngIf="!result.showTextBox && !result.hideYesBtn"
  >
    {{ result.yes }}
  </button>
  <button
    mat-button
    color="primary"
    (click)="save()"
    *ngIf="result.showTextBox && !result.hideYesBtn "
  >
    {{ result.yes }}
  </button>
</div>
